import React, { useCallback } from 'react';
import { func, number, shape } from 'prop-types';

const ShopByPriceRange = ({ range, onPriceRangeClick }) => {
    const handlePriceRangeClick = useCallback(() => {
        onPriceRangeClick(range);
    }, [range, onPriceRangeClick]);
    return (
        <button
            key={`${range.from}-${range.to}`}
            onClick={handlePriceRangeClick}
            className={'shop-by-price--range'}
        >
            ${range.from} - ${range.to}
        </button>
    );
};

ShopByPriceRange.propTypes = {
    range: shape({
        from: number.isRequired,
        to: number.isRequired,
    }).isRequired,
    onPriceRangeClick: func.isRequired,
};
export default ShopByPriceRange;